export default function (Vue) {
  Vue.filter('filterSens', function (str) {
    // userType：1运营     2租户     4客服   5质检  6业务  7其他
    let userType = JSON.parse(window.localStorage.user).info.userType
    if (userType !== "2" && str) {
      if(window.localStorage.desensitization === '1') {
        return (str.substring(0, 3) + '****' + str.substring(3 + 4))
      }else if(window.localStorage.desensitization === '2') {
        let len = str.length
        let countStr = ''
        for(let i = 0; i < len; i ++) {
          countStr += '*'
        }
        return countStr
      }else if(window.localStorage.desensitization === '0') {
        return str
      }
  } else {
      return str
  }
  })
}
